import React, { useState } from "react";
import { Country, State } from "country-state-city";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const BillingsInfo = () => {
  const dispatch = useDispatch();
  const history = useNavigate();
  // const { shippingInfo } = useSelector((state) => state.products);
  // const [address, setAddress] = useState(shippingInfo.address);
  // const [state, setState] = useState(shippingInfo.state);
  // const [country, setCountry] = useState(shippingInfo.country);
  // const [pincode, setPincode] = useState(shippingInfo.pincode);
  // const [phone, setPhone] = useState(shippingInfo.phone);
  // const [name, setName] = useState(shippingInfo.name);

  // const handleShippingSubmit = (e) => {
  //   e.preventDefault();
  //   dispatch({
  //     type: "products/shippingDetail",
  //     payload: { address, state, country, pincode, phone, name },
  //   });
  //   history("/my-acount");
  // };

  return (
    <>
      <div className="col-lg-6 col-md-12 col-sm-12 col-12">
        <div className="checkout-area-bg bg-white">
          <div className="check-heading">
            <h3>Billings Information</h3>
          </div>
          <div className="check-out-form">
            <form method="post" onSubmit={"handleShippingSubmit"}>
              <div className="row">
                <div className="col-lg-6 col-md-12 col-sm-=12 col-12">
                  <div className="form-group">
                    <label htmlFor="fname">
                      Full name<span className="text-danger">*</span>{" "}
                    </label>
                    <input
                      type="text"
                      required={true}
                      // value={name}
                      className="form-control"
                      id="fname"
                      placeholder="Full name"
                      // onChange={(e) => setName(e.target.value)}
                    />
                  </div>
                </div>

                <div className="col-lg-12 col-md-12 col-sm-=12 col-12">
                  <div className="form-group">
                    <label htmlFor="cname">
                      Phone Number<span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      required={true}
                      // value={phone}
                      type="phone"
                      id="cname"
                      placeholder="Phone Number"
                      // onChange={(e) => setPhone(e.target.value)}
                    />
                  </div>
                </div>

                <div className="col-lg-12 col-md-12 col-sm-=12 col-12">
                  <div className="form-group">
                    <label htmlFor="country">
                      Country<span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-control first_null"
                      id="country"
                      // value={country}
                      // onChange={(e) => setCountry(e.target.value)}
                    >
                      <option defaultValue="">Select an option...</option>
                      {Country?.getAllCountries().map((item) => (
                        <option key={item.isoCode} value={item.isoCode}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                {/* {country && ( */}
                  <div className="col-lg-6 col-md-12 col-sm-=12 col-12">
                    <div className="form-group">
                      <label htmlFor="zip">
                        State/City<span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control first_null"
                        id="state"
                        // value={state}
                        // onChange={(e) => setState(e.target.value)}
                      >
                        <option defaultValue="">Select an option...</option>
                        {/* {State?.getStatesOfCountry(country).map((item) => (
                          <option key={item.isoCode} value={item.isoCode}>
                            {item.name}
                          </option>
                        ))} */}
                      </select>
                    </div>
                  </div>
                {/* )}  */}

                <div className="col-lg-12 col-md-12 col-sm-=12 col-12">
                  <div className="form-group">
                    <label htmlFor="pincode">
                      Pincode<span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      required=""
                      type="text"
                      // value={pincode}
                      id="pincode"
                      placeholder="000000"
                      // onChange={(e) => setPincode(e.target.value)}
                    />
                  </div>
                </div>

                <div className="col-lg-12 col-md-12 col-sm-=12 col-12">
                  <div className="form-group">
                    <label htmlFor="faddress">
                      Full Address<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="faddress"
                      // value={address}
                      required=""
                      placeholder="Enter your address here.."
                      // onChange={(e) => setAddress(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-=12 col-12">
                  <div className="form-group">
                    <label htmlFor="messages">
                      Additional Notes<span className="text-danger">*</span>
                    </label>
                    <textarea
                      rows="5"
                      className="form-control"
                      id="messages"
                      placeholder="Order notes"
                    ></textarea>
                  </div>
                </div>
              </div>
              <button
                type="submit"
                className="theme-btn-one btn-black-overlay btn_sm"
              >
                Place Order
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default BillingsInfo;
